//This is necessary to preserve old urls on press releases and security advisories.
import Slugify from "slugify"

const FastlySlugify = (text) => {
  if (!text) {
    return ""
  }

  const scrubbedText = text
    .replace(/é/g, "e")
    .replace(/’/g, "")
    .replace(/(\.|\/|&|\$|')/g, "")
    .replace(/(@)/g, " ")
    .replace(/ ((a|at|for|into|in|is|of|the|to|with|of the|into the|of a|of an|of the|and a|in a) )+/g, " ")
    .replace(/(A|At|For|Into|In|Is|Of|The|To|With) /g, " ")
  return Slugify(scrubbedText, { lower: true, remove: /[,:?]/g })
}

export default FastlySlugify
